module.exports = __webpack_public_path__ + "img/booking.2d1a3e2e.svg";